import { io, Socket } from "socket.io-client"
import { useAuthStore } from "../../stores/auth-store"
import { useCallStore } from "../../stores/call-store"
import { keys } from "../../keys"
import { hydrateCurrentCallFromServer } from "../call-center/current-call-sync"

let socket: Socket | null = null

export function initSocket(): Socket {
  if (socket?.connected) {
    return socket
  }

  const token = useAuthStore.getState().token

  socket = io(keys.SOCKET_URL, {
    auth: {
      token,
    },
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  })

  socket.on("connect", () => {
    // Re-join agent room on reconnect if Twilio device is active
    const { browserDialing, currentCall } = useCallStore.getState()
    if (browserDialing === "ready") {
      socket?.emit("JOIN_AGENT_ROOM", {})

      // Reconcile any active call state after reconnect. Do NOT clear the
      // store if the server returns no call: during a reconnect race the
      // server may not have re-mapped this socket back to the agent's call
      // yet, and the local store is authoritative while Twilio still holds
      // the live connection. Subsequent socket events will reconcile if the
      // call genuinely ended.
      if (currentCall || useAuthStore.getState().user?.agent_current_call) {
        void hydrateCurrentCallFromServer("socket-reconnect", {
          clearIfMissing: false,
        }).catch(() => {
          // Non-critical — socket events will eventually reconcile
        })
      }
    }
  })

  socket.on("disconnect", () => {
    // Disconnected
  })

  socket.on("connect_error", () => {
    // Connection error
  })

  return socket
}

export function getSocket(): Socket | null {
  return socket
}

export function disconnectSocket(): void {
  if (socket) {
    socket.disconnect()
    socket = null
  }
}

// Re-export for convenience
export { socket }
